const l=(l,p)=>p?p.split("/p/")[1].split("/")[l]:null;export{l as parseProductUrl};
